import React from 'react';
import { useTranslation } from 'react-i18next';
import { Project60StickyBanner as Quiz4UrgencyBanner } from '../Quiz4UrgencyBanner';
import { FallSaleBanner } from './FallSaleBanner';
import { Web48Arm } from '../../web48Offer';
import { BfSale } from '../../bfSale';

interface Web48BannerProps {
  arm: Web48Arm;
  endsAt?: number;
  // Black Friday sale: same two designs with the sale's label, percent and
  // end date (bfSale.ts). Absent outside the sale.
  sale?: BfSale | null;
}

// web48_timer_banner: the one banner a web48 visitor sees on quiz pages and
// pricing. Same copy and end date in both arms; only the UI differs.
//   control   – today's banner, "EXCLUSIVE FALL SALE" copy, days:hrs:min:sec pill
//   variation – Oben's bar (FallSaleBanner)
// Past the end date both keep their copy and say "ends today" where the
// countdown was (Steven, Oct 30); the price never changes.
// During the Black Friday sale both designs read "EARLY BLACK FRIDAY" (or
// "BLACK FRIDAY") with the sale percent and count down to the sale's end.
export const Web48Banner = ({ arm, endsAt, sale }: Web48BannerProps) => {
  const { t } = useTranslation();
  const label = sale ? t(`results.banner.bf2026.${sale.phase}.saleLabel`) : t('results.banner.web48.saleLabel');
  const lead = sale ? t(`results.banner.bf2026.${sale.phase}.saleLead`) : t('results.banner.web48.saleLead');
  const percent = sale ? sale.percent : 20;
  const until = sale ? sale.endsAt : endsAt;
  if (arm === 'variation') return <FallSaleBanner endsAt={until} label={label} percent={percent} />;

  // Ethan, Oct 30: control reads "EXCLUSIVE FALL SALE: Get 20% Off + 14 Days Free".
  const offer = t('results.banner.web48.controlOffer', { percent });
  return (
    <div data-testid="web48-control-banner">
      <Quiz4UrgencyBanner
        line1={label}
        line2={offer}
        line3={`${lead} ${offer}`}
        showTimer={until !== undefined}
        showDays
        expiresAt={until}
        endedText={t('results.banner.web48.endsToday')}
      />
    </div>
  );
};
